/*
 * MTO Auto Add — kurala bağlı sepete otomatik ürün (hediye) ekleme motoru (MTO-Publish / Be Yours 9.5.1).
 * Ayarlar: sections/mto-auto-add.liquid · sepet durumu: snippets/mto-auto-add-state.liquid ·
 * sepette kilitli satır: snippets/mto-auto-add-gift.liquid (mini-cart + main-cart-items).
 *
 * Hız
 *  - Sepet durumu (koleksiyonlar, etiketler, tüm indirimler düşülmüş net tutar dahil) sunucuda hesaplanır ve
 *    temanın kendi çekmece/sepet section yanıtlarında gelir: ürün formu, hızlı ekle, bundle, çekmecede adet/sil,
 *    kupon sonrası ek okuma yapılmaz. Sayfa açılışında sepet zaten doğruysa hiç istek atılmaz.
 *  - Değişiklik en fazla iki istektir (çıkar/düzelt: /cart/update.js, ekle: /cart/add.js); sonuncusu çekmece ve
 *    sepet section'larını da ister, tema kendi PUB_SUB cartUpdate akışıyla çizer. Çekmece kendiliğinden açılmaz.
 *  - Tema dışı istekler (uygulama, XHR) PerformanceObserver ile yakalanır; durum tek Section Rendering isteğiyle
 *    tazelenir.
 *
 * Güvenlik
 *  - Tüm işler tek kuyrukta sıralanır (çift ekleme yok). Kendi isteğimizle çakışmış olabilecek bir tema yanıtı
 *    ya da sayfa açılışındaki durum, sepete yazmadan önce tazelenir.
 *  - Her yazmadan sonra yanıttaki durumla sepet yeniden doğrulanır (en fazla 3 tur).
 *  - Stok/kural hatası veren hediye 60 sn yeniden denenmez (istek yağmuru yok).
 */
(() => {
  if (customElements.get('mto-auto-add')) return;

  const GIFT = '_mto_gift';
  const CAMPAIGN = '_mto_campaign';
  const MUTATION = /\/cart\/(add|change|update|clear)(\.js)?$/;
  const STATE = /<script[^>]*data-mto-auto-add-state[^>]*>([\s\S]*?)<\/script>/;
  const MAX_SECTIONS = 5; // Shopify: 5'ten fazla section isteği 400 döner
  const SUSPECT_MS = 2500;
  const BLOCK_MS = 60000;
  const MAX_ROUNDS = 3;

  const log = (...args) => console.warn('[MTO Auto Add]', ...args);
  const clock = () => performance.now();

  /* Liquid'in bastığı durum bloğunu bir HTML parçasından okur (DOMParser'sız, hızlı). */
  const readState = (html) => {
    if (typeof html !== 'string') return null;
    const match = html.match(STATE);
    if (!match) return null;
    try {
      const state = JSON.parse(match[1]);
      return Array.isArray(state.items) ? state : null;
    } catch (_) {
      return null;
    }
  };

  const stateFromSections = (sections) => {
    if (!sections || typeof sections !== 'object') return null;
    for (const key of Object.keys(sections)) {
      const state = readState(sections[key]);
      if (state) return state;
    }
    return null;
  };

  /* "2026-11-01 00:00", "2026-11-01", "01.11.2026 00:00", "01.11.2026" → mağaza saatiyle ms.
     Boş → null (sınır yok), okunamayan → NaN (kural güvenli tarafta kapalı kalır). */
  const parseWhen = (value, offset) => {
    const text = String(value || '').trim();
    if (!text) return null;
    let y, mo, d, h = '0', mi = '0', m;
    if ((m = text.match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2})[:.](\d{2}))?$/))) [, y, mo, d, h = '0', mi = '0'] = m;
    else if ((m = text.match(/^(\d{1,2})[./](\d{1,2})[./](\d{4})(?:\s+(\d{1,2})[:.](\d{2}))?$/))) [, d, mo, y, h = '0', mi = '0'] = m;
    else return NaN;
    const pad = (n) => String(n).padStart(2, '0');
    const zone = /^[+-]\d{4}$/.test(offset || '') ? `${offset.slice(0, 3)}:${offset.slice(3)}` : 'Z';
    const at = Date.parse(`${y}-${pad(mo)}-${pad(d)}T${pad(h)}:${pad(mi)}:00${zone}`);
    return Number.isNaN(at) ? NaN : at;
  };

  const endpoint = (key, fallback) => {
    const base = (window.theme && theme.routes && theme.routes[key]) || fallback;
    return /\.js$/.test(base) ? base : `${base}.js`;
  };

  const money = (cents) => {
    try {
      if (window.theme && theme.Currency && theme.shopSettings) {
        return theme.Currency.formatMoney(cents, theme.shopSettings.moneyFormat);
      }
    } catch (_) {}
    return (cents / 100).toFixed(2);
  };

  class Engine {
    constructor() {
      this.config = null;
      this.host = null;
      this.job = null;
      this.running = false;
      this.inFlight = false;
      this.lastOwnEnd = -Infinity;
      this.lastStateAt = -Infinity;
      this.freshAt = -Infinity;
      this.own = [];
      this.blocked = new Map();
      this.listening = false;
      this.hiddenAt = 0;
      this.timer = 0;
    }

    attach(host) {
      let config;
      try {
        config = JSON.parse(host.querySelector('[data-mto-auto-add-config]').textContent);
      } catch (error) {
        log('ayarlar okunamadı', error);
        return;
      }
      this.host = host;
      this.config = this.normalize(config);
      this.listen();
      this.schedule();
      let state = null;
      try {
        state = JSON.parse(host.querySelector('[data-mto-auto-add-state]').textContent);
      } catch (_) {}
      this.request({ state: state && Array.isArray(state.items) ? state : null, initial: true });
    }

    detach(host) {
      if (this.host !== host) return;
      this.host = null;
      this.config = null;
      clearTimeout(this.timer);
    }

    normalize(config) {
      // Eşikler mağaza para biriminde; sepet tutarları müşterinin para biriminde gelir.
      const rate = parseFloat(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1;
      const rules = (config.rules || []).map((rule) => ({
        ...rule,
        qty: Math.max(1, parseInt(rule.qty, 10) || 1),
        collections: new Set((rule.collections || []).map(Number)),
        products: new Set((rule.products || []).map(Number)),
        tag: String(rule.tag || '').trim().toLowerCase(),
        min: Math.round((rule.min || 0) * rate),
        max: Math.round((rule.max || 0) * rate),
        minQty: Math.max(0, parseInt(rule.minQty, 10) || 0),
        start: parseWhen(rule.start, config.offset),
        end: parseWhen(rule.end, config.offset),
      }));
      return { ...config, rules };
    }

    /* ── Olaylar ─────────────────────────────────────────────── */

    listen() {
      if (this.listening) return;
      this.listening = true;

      const fromTheme = (payload) => {
        if (!this.config) return;
        const state = stateFromSections(payload && payload.sections);
        if (!state) {
          this.request({ fresh: true });
          return;
        }
        this.lastStateAt = clock();
        this.request({ state, suspect: this.inFlight || clock() - this.lastOwnEnd < SUSPECT_MS });
      };

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (event && event.source !== 'mto-auto-add') fromTheme(event.cart);
        });
      }
      document.addEventListener('ajaxProduct:added', (event) => fromTheme(event.detail && event.detail.product));
      document.addEventListener('cart:refresh', () => this.request({ fresh: true }));

      this.observe();

      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'hidden') {
          this.hiddenAt = Date.now();
        } else if (this.hiddenAt && Date.now() - this.hiddenAt > 15000) {
          this.hiddenAt = 0;
          this.request({ fresh: true, ui: true }); // başka sekmede sepet değişmiş olabilir
        }
      });
      window.addEventListener('pageshow', (event) => {
        if (event.persisted) this.request({ fresh: true, ui: true });
      });
    }

    /* Tema olayı yaymayan sepet istekleri (uygulamalar, XHR). Tema istekleri zaten durumla gelir:
       150 ms içinde o istekten daha yeni bir durum alınmadıysa tazele. */
    observe() {
      try {
        new PerformanceObserver((list) => {
          for (const entry of list.getEntries()) {
            if (entry.initiatorType !== 'fetch' && entry.initiatorType !== 'xmlhttprequest') continue;
            let path = '';
            try {
              path = new URL(entry.name, location.href).pathname;
            } catch (_) {}
            if (!MUTATION.test(path) || this.isOwn(entry)) continue;
            const end = entry.responseEnd;
            setTimeout(() => {
              if (this.lastStateAt < end && this.freshAt < end) this.request({ fresh: true });
            }, 150);
          }
        }).observe({ type: 'resource' });
      } catch (_) {
        /* eski tarayıcı: tema olayları yeterli */
      }
    }

    isOwn(entry) {
      return this.own.some((start) => Math.abs(entry.startTime - start) < 5);
    }

    /* Kampanya penceresi sayfa açıkken başlar/biterse o anda yeniden değerlendir. */
    schedule() {
      clearTimeout(this.timer);
      if (!this.config) return;
      const now = Date.now();
      let next = Infinity;
      for (const rule of this.config.rules) {
        for (const at of [rule.start, rule.end]) if (Number.isFinite(at) && at > now) next = Math.min(next, at);
      }
      if (next - now < 864e5) {
        this.timer = setTimeout(() => {
          this.request({ fresh: true, ui: true });
          this.schedule();
        }, next - now + 500);
      }
    }

    /* ── Kuyruk ──────────────────────────────────────────────── */

    request(job) {
      if (!this.config) return;
      if (job.fresh) this.freshAt = clock(); // bundan önce biten istekleri bu tazeleme zaten kapsar
      const queued = this.job || (this.job = { state: null, suspect: false, fresh: false, ui: false, initial: false });
      if (job.state) {
        queued.state = job.state; // en yeni durum kazanır
        queued.suspect = !!job.suspect;
      }
      queued.fresh = queued.fresh || !!job.fresh;
      queued.ui = queued.ui || !!job.ui;
      queued.initial = queued.initial || !!job.initial;
      if (!this.running) this.drain();
    }

    async drain() {
      this.running = true;
      await Promise.resolve(); // aynı anda gelen olayları tek işte birleştir
      while (this.job && this.config) {
        const job = this.job;
        this.job = null;
        try {
          await this.run(job);
        } catch (error) {
          log(error);
        }
      }
      this.running = false;
    }

    async run(job) {
      let state = job.fresh ? null : job.state;
      let fresh = null;
      if (!state) {
        fresh = await this.fetchState(job.ui);
        state = fresh.state;
      }
      if (!state) return;

      let plan = this.plan(state);
      if (!plan.empty && !fresh && (job.suspect || job.initial)) {
        // Bu durum kendi isteğimizle çakışmış ya da sayfa önbellekten gelmiş olabilir: yazmadan önce tazele.
        fresh = await this.fetchState(true);
        if (!fresh.state) return;
        plan = this.plan(fresh.state);
        state = fresh.state;
      }
      this.report(plan);

      if (plan.empty) {
        if (fresh && fresh.sections) this.render({ sections: fresh.sections }, state);
        return;
      }
      await this.commit(plan);
    }

    /* ── Kural değerlendirme ─────────────────────────────────── */

    status(rule, now) {
      if (!this.config.enabled) return 'off';
      if (!rule.enabled) return 'disabled';
      if (!rule.variant) return 'noproduct';
      if (!rule.customer) return 'customer';
      if (Number.isNaN(rule.start) || Number.isNaN(rule.end)) return 'baddate';
      if (rule.start !== null && now < rule.start) return 'early';
      if (rule.end !== null && now >= rule.end) return 'late';
      return 'active';
    }

    inScope(rule, line) {
      switch (rule.scope) {
        case 'collections':
          return (line.c || []).some((id) => rule.collections.has(id));
        case 'products':
          return rule.products.has(line.p);
        case 'tag':
          return !!rule.tag && (line.t || []).some((tag) => String(tag).toLowerCase() === rule.tag);
        default:
          return true;
      }
    }

    measure(rule, lines) {
      let amount = 0;
      let qty = 0;
      for (const line of lines) {
        if (!this.inScope(rule, line)) continue;
        amount += rule.basis === 'list' ? line.l : line.n;
        qty += line.q;
      }
      return { amount, qty };
    }

    met(rule, { amount, qty }) {
      if (qty <= 0) return false;
      const checks = [];
      if (rule.min > 0) checks.push(amount >= rule.min);
      if (rule.minQty > 0) checks.push(qty >= rule.minQty);
      let ok = !checks.length || (rule.logic === 'or' ? checks.some(Boolean) : checks.every(Boolean));
      if (ok && rule.max > 0 && amount >= rule.max) ok = false;
      return ok;
    }

    /* Sepetin olması gereken hâli → yapılacak değişiklikler.
       Hediye satırı = _mto_gift taşıyan satır ya da "yalnızca hediye" ürünün işaretsiz satırı; hiçbiri koşula sayılmaz. */
    plan(state) {
      const { rules } = this.config;
      const now = Date.now();
      const giftOnly = new Set(rules.filter((rule) => rule.giftOnly && rule.variant).map((rule) => rule.variant));
      const gifts = [];
      const eligible = [];
      for (const line of state.items) (line.g || giftOnly.has(line.v) ? gifts : eligible).push(line);

      const updates = {};
      const adds = [];
      const report = [];
      const claimed = new Set();

      for (const rule of rules) {
        const status = this.status(rule, now);
        const measured = this.measure(rule, eligible);
        const met = status === 'active' && this.met(rule, measured);
        const mine = gifts.filter((line) => line.g === rule.id);
        mine.forEach((line) => claimed.add(line));
        const keep = mine.find((line) => line.v === rule.variant) || null;

        let want = 0;
        if (status === 'active' && (met || (keep && !rule.removeUnmet))) want = rule.qty;

        for (const line of mine) if (line !== keep) updates[line.k] = 0;

        let note = '';
        if (keep) {
          if (keep.q !== want) updates[keep.k] = want;
        } else if (want > 0) {
          if (!rule.available) note = 'stock';
          else if ((this.blocked.get(rule.id) || 0) > now) note = 'blocked';
          else {
            const properties = { [GIFT]: rule.id };
            if (rule.title) properties[CAMPAIGN] = rule.title;
            adds.push({ id: rule.variant, quantity: want, properties });
          }
        }
        report.push({ rule, status, met, want, note, has: keep ? keep.q : 0, ...measured });
      }

      // Kuralı silinmiş işaretli satırlar ve elle eklenmiş "yalnızca hediye" ürünler
      for (const line of gifts) if (!claimed.has(line)) updates[line.k] = 0;

      return { updates, adds, report, empty: !Object.keys(updates).length && !adds.length };
    }

    /* ── Sepete yazma ────────────────────────────────────────── */

    async commit(plan, round = 1) {
      const removing = Object.keys(plan.updates).filter((key) => plan.updates[key] === 0);
      const sections = this.uiSections();
      const render = sections.length ? { sections: sections.join(','), sections_url: location.pathname } : {};
      let last = null;

      this.fade(removing, true);
      this.inFlight = true;
      try {
        if (Object.keys(plan.updates).length) {
          last = await this.post(endpoint('cart_update_url', '/cart/update'), {
            updates: plan.updates,
            ...(plan.adds.length ? {} : render),
          });
        }
        if (plan.adds.length) last = await this.add(plan.adds, render);
      } catch (error) {
        log(error.message || error);
        this.fade(removing, false);
        last = null;
      } finally {
        this.inFlight = false;
        this.lastOwnEnd = clock();
      }

      let state = stateFromSections(last && last.sections);
      if (state) {
        this.lastStateAt = clock();
        this.render(last, state);
      } else {
        // Yanıtta section yok (hata, kısmi ekleme): arayüzü ve durumu tek istekle tazele.
        const fresh = await this.fetchState(true).catch(() => ({}));
        state = fresh.state || null;
        if (fresh.sections) this.render({ ...(last || {}), sections: fresh.sections }, state);
      }

      if (state && round < MAX_ROUNDS) {
        const again = this.plan(state);
        this.report(again);
        if (!again.empty) await this.commit(again, round + 1);
      }
    }

    async add(items, render) {
      const url = endpoint('cart_add_url', '/cart/add');
      try {
        return await this.post(url, { items, ...render });
      } catch (error) {
        if (error.status !== 422) throw error;
        if (items.length === 1) {
          this.block(items[0]);
          throw error;
        }
        // Birden çok hediyeden biri eklenemedi: tek tek dene, sorunluyu beklet.
        let last = null;
        for (const [index, item] of items.entries()) {
          try {
            last = await this.post(url, { items: [item], ...(index === items.length - 1 ? render : {}) });
          } catch (itemError) {
            if (itemError.status !== 422) throw itemError;
            this.block(item);
          }
        }
        return last;
      }
    }

    block(item) {
      const id = item.properties && item.properties[GIFT];
      if (id) this.blocked.set(id, Date.now() + BLOCK_MS);
      log('hediye eklenemedi, 60 sn beklenecek', id);
    }

    async post(url, body) {
      this.own.push(clock());
      if (this.own.length > 20) this.own.shift();
      const response = await fetch(url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      let data = null;
      try {
        data = await response.json();
      } catch (_) {}
      if (!response.ok || (data && typeof data.status === 'number' && data.status >= 400)) {
        const error = new Error((data && (data.description || data.message)) || `HTTP ${response.status}`);
        error.status = (data && typeof data.status === 'number' && data.status) || response.status;
        throw error;
      }
      return data;
    }

    /* Durum + (istenirse) arayüz section'ları, bulunulan sayfanın bağlamında tek istekle. */
    async fetchState(withUi) {
      const id = this.config.sectionId;
      const ids = [id];
      if (withUi) for (const sectionId of this.uiSections()) if (ids.length < MAX_SECTIONS && !ids.includes(sectionId)) ids.push(sectionId);
      const url = new URL(location.pathname, location.origin);
      url.searchParams.set('sections', ids.join(','));
      // Accept başlığı YOK: ürün/koleksiyon URL'sinde "Accept: application/json" section yerine kaynağın JSON'unu döndürür.
      const response = await fetch(url, { credentials: 'same-origin' });
      if (!response.ok) throw new Error(`durum okunamadı (HTTP ${response.status})`);
      const data = await response.json();
      const state = readState(data[id]);
      if (state) this.lastStateAt = clock();
      delete data[id];
      return { state, sections: withUi && Object.keys(data).length ? data : null };
    }

    /* Sayfada çizilecek sepet section'ları (en fazla 5): sepet sayfası ya da çekmece + sayaçlar. */
    uiSections() {
      const ids = [];
      const add = (id) => {
        if (id && !ids.includes(id) && ids.length < MAX_SECTIONS) ids.push(id);
      };
      const page = document.querySelector('#main-cart-items[data-id]');
      if (page) add(page.dataset.id);
      const footer = document.querySelector('#main-cart-footer[data-id]');
      if (footer) add(footer.dataset.id);
      if (document.getElementById('mini-cart')) add('mini-cart');
      for (const id of ['cart-icon-bubble', 'mobile-cart-icon-bubble', 'cart-live-region-text']) {
        if (document.getElementById(id)) add(id);
      }
      return ids;
    }

    /* Temanın kendi akışıyla çiz: cart-items (çekmece + sepet sayfası), avantaj merdiveni vb. dinler. */
    render(response, state) {
      const sections = response && response.sections;
      if (!sections) return;
      const cart = { ...response };
      if (typeof cart.item_count !== 'number' && state) cart.item_count = state.count;
      if (!document.querySelector('cart-items')) this.paint(sections); // çekmece henüz yüklenmediyse sayaçlar bizden
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mto-auto-add', cart });
      }
    }

    paint(sections) {
      for (const id of ['cart-icon-bubble', 'mobile-cart-icon-bubble']) {
        const element = document.getElementById(id);
        if (!element || !sections[id]) continue;
        const next = new DOMParser().parseFromString(sections[id], 'text/html').querySelector('.shopify-section');
        if (next) (element.querySelector('.shopify-section') || element).innerHTML = next.innerHTML;
      }
    }

    /* Çıkarılacak satır istek sürerken temanın kendi "kaldırılıyor" görünümüne geçer. */
    fade(keys, on) {
      for (const key of keys) {
        document.querySelectorAll(`[data-key="${CSS.escape(key)}"]`).forEach((row) => {
          row.classList.toggle('cart-item--removing', on);
        });
      }
    }

    /* ── Düzenleyici tanı paneli ─────────────────────────────── */

    report(plan) {
      if (!this.config || !this.config.designMode) return;
      const panel = document.querySelector('[data-mto-auto-add-panel]');
      if (!panel) return;
      const label = {
        off: 'Sistem kapalı.',
        disabled: 'Kural kapalı.',
        noproduct: 'Hediye ürün seçilmedi.',
        customer: 'Bu müşteri için geçerli değil (müşteri koşulu).',
        baddate: 'Tarih okunamadı — örnek: 2026-11-01 00:00',
        late: 'Kampanya süresi doldu.',
      };
      for (const item of plan.report) {
        const node = panel.querySelector(`[data-rule-status="${CSS.escape(item.rule.id)}"]`);
        if (!node) continue;
        const { rule } = item;
        const counted = `Önizleme sepeti: ${money(item.amount)} · ${item.qty} adet`;
        let text;
        let tone = 'off';
        if (item.status === 'early') text = `Henüz başlamadı (${new Date(rule.start).toLocaleString('tr-TR')}).`;
        else if (item.status !== 'active') text = label[item.status];
        else if (item.note === 'stock') text = `Koşul sağlanıyor ama hediye stokta yok. ${counted}`;
        else if (item.note === 'blocked') text = `Hediye eklenemedi (stok/kural); 60 sn sonra yeniden denenecek. ${counted}`;
        else if (item.met) {
          tone = 'ok';
          text = `Koşul sağlanıyor — hediye sepette. ${counted}`;
        } else {
          const gaps = [];
          if (rule.min > item.amount) gaps.push(`${money(rule.min - item.amount)} eksik`);
          if (rule.minQty > item.qty) gaps.push(`${rule.minQty - item.qty} adet eksik`);
          if (rule.max > 0 && item.amount >= rule.max) gaps.push('üst sınır aşıldı');
          if (!item.qty) gaps.push('sayılan ürün yok');
          text = `Koşul sağlanmıyor${gaps.length ? ` (${gaps.join(', ')})` : ''}. ${counted}`;
        }
        node.textContent = text;
        node.dataset.tone = tone;
      }
    }
  }

  const engine = new Engine();

  customElements.define(
    'mto-auto-add',
    class extends HTMLElement {
      connectedCallback() {
        engine.attach(this);
      }

      disconnectedCallback() {
        engine.detach(this);
      }
    }
  );
})();
